module.exports = __webpack_public_path__ + "static/media/check-circle.96156094.svg";